import { GRAPHQL_ERROR, NETWORK_ERROR, RESET_ERROR, NO_WSS_AUTH_ERROR } from "../constants/error";

const initialState = {
  networkError: undefined,
  graphqlError: undefined,
  noWssAuthError: false
};
export default (state = initialState, action) => {
  switch (action.type) {
    case GRAPHQL_ERROR:
      return {
        ...state,
        graphqlError: action.payload
      };
    case NETWORK_ERROR:
      return {
        ...state,
        networkError: action.payload
      };
    case RESET_ERROR:
      if (action.payload === GRAPHQL_ERROR)
        return {
          ...state,
          graphqlError: undefined
        };
      if (action.payload === NETWORK_ERROR)
        return {
          ...state,
          networkError: undefined
        };
      return state;
    case NO_WSS_AUTH_ERROR:
      return {
          ...state,
          noWssAuthError: true
      };
    default:
      return state;
  }
};
